<!--  -->
<template>
  <div>
    <div class="activityList box">
      <div
        v-for="(item,index) in activityList"
        :key="index"
        style="position:relative;margin-bottom:20px"
        :style="{marginLeft: cardMargin+'px'}"
        @click="router(item.id)"
      >
        <Card class="card-warpper" :padding="0">
          <div v-if="isCaogao == 'fabu'">
            <div
              class="triangle"
              :style="{borderTopColor: item.status == 2?'#47ba53':item.status==0?'#a1afb2':'#ff7b43'}"
            ></div>
            <div class="triangle-info">{{item.status == 2?'已结束':item.status==0?'未开始':'核销中'}}</div>
          </div>
          <div style="margin: 20px auto;width: fit-content;">
            <img v-if="item.cover" :src="item.cover" class="coverimg">
            <div v-else class="zhanwei">暂无封面图</div>
          </div>

          <div class="title1">{{item.title?item.title:'暂无标题'}}</div>
          <div class="footer">
            <div v-if="isCaogao == 'fabu'" style="margin-right: 20px">
              <span class="">兑换</span>
              <span class="number">{{item.orderNumber}}/{{item.quantity}}</span>
            </div>
            <div v-if="isCaogao == 'fabu'">
              <span class="">核销</span>
              <span class="number">{{item.consumeNumber}}/{{item.quantity}}</span>
            </div>
            <Poptip placement="bottom" class="editIcon" trigger="hover" width="130">
              <div class="iconfont icon-caidan1 card-menu"></div>
              <div slot="content">
                <div class="box-v pop-wrapper">
                  <div
                    :style="{background:changeState=='chehui'?'#f1f1f1':''}"
                    @mouseover="change('chehui')"
                    @mouseout="change('')"
                    v-if="isCaogao == 'fabu'"
                    @click="backActiveDraft(item.id)"
                  >撤回
                  </div>
                  <div
                    :style="{background:changeState=='shanchu'?'#f1f1f1':''}"
                    @mouseover="change('shanchu')"
                    @mouseout="change('')"
                    v-else
                    @click="deleteMe(item)"
                  >删除
                  </div>
                </div>
              </div>
            </Poptip>
          </div>
        </Card>
      </div>
    </div>
    <Modal v-model="chexiao" @on-ok="ok" :mask-closable="false">
      <p style="text-align:center;height:50px;line-height:50px;font-size:20px;">确定撤销？</p>
    </Modal>
    <Modal v-model="shanchu" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>是否确认删除？</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="del()" :loading="shanchuIng">删除</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      activityList: {
        type: Array,
        default: []
      },
      contentWidth: {
        type: Number,
        default: 1510 //默认1920浏览器宽度
      },
      isCaogao: {
        type: String,
        default: 'fabu'
      }
    },
    data() {
      //这里存放数据
      return {
        changeState: "",
        chexiao: false,
        activityId: "", //撤回用id
        shanchu: false,
        shanchuIng: false,
        actid: "",//删除用id
      };
    },
    //监听属性 类似于data概念
    computed: {
      cardMargin() {
        let cardNumber = parseInt(this.contentWidth / 328);
        let totalMargin = this.contentWidth - cardNumber * 328;
        return totalMargin / (cardNumber + 1);
      }
    },
    //方法集合
    methods: {
      change(item) {
        this.changeState = item;
      },
      router(id) {
        if (this.isCaogao == 'fabu') {
          this.$router.push({name: "goodDetail", query: {id}});
        } else {
          this.$router.push({name: "newExchange", query: {id}});
        }
      },
      backActiveDraft(id) {
        //点击撤销    弹出model
        event.stopPropagation();
        this.chexiao = true;
        this.activityId = id;
      },
      ok() {
        var that = this;
        var url = this.urlobj.delGood(this.activityId) + `?isDelete=0`;
        this.$delete(url).then(function (res) {
          that.$emit("init"); //1是已发送  0是草稿
        });
      },
      deleteMe(val) {
        console.log(val)
        event.stopPropagation();
        this.shanchu = true;
        this.actid = val.id;
      },
      del() {
        var that = this;
        that.shanchuIng = true;
        var url = this.urlobj.delGood(this.actid) + `?isDelete=1`;
        this.$delete(url).then(function (res) {
          that.shanchu = false;
          that.shanchuIng = false;
          that.$emit("init"); //1是已发送  0是草稿
        });
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style lang='less' scoped>
  .activityList {
    flex-wrap: wrap;
  }

  // 卡片样式
  .card-warpper {
    width: 328px;
  }

  .coverimg {
    display: block;
    width: 290px;
    height: 180px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .zhanwei {
    background: #ddd;
    text-align: center;
    height: 180px;
    line-height: 200px;
    width: 290px;
  }

  .title1 {
    padding: 0 20px;
    margin-bottom: 20px;
    // box-sizing: content-box;
    color: #4b4b4b;
    font-size: 18px;
    height: 2.4em;
    line-height: 1.2em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .footer {
    padding: 0 20px;
    display: flex;
    align-items: center;
    border-top: 1px solid #eee;
    height: 46px;
    color: #556b93;
    .delete-text {
      font-size: 20px;
    }
    .number {
      /*margin: 0 48px 0 10px;*/
      /*color: #666;*/
      /*font-size: 15px;*/
      /*vertical-align: text-bottom;*/
    }
  }

  .triangle {
    position: absolute;
    top: 20px;
    left: 18px;
    width: 0;
    height: 0;
    border-top: 60px solid #47ba53;
    border-right: 60px solid transparent;
  }

  .triangle-info {
    position: absolute;
    top: 30px;
    left: 20px;
    color: #fff;
    transform: rotate(-45deg);
  }

  .editIcon {
    margin-left: auto;
    line-height: 13px;
    z-index: 999;
    &:hover {
      cursor: pointer;
    }
  }

  .card-menu {
    font-size: 25px;
    color: #707070;
    line-height: 0.8em;
    text-align: center;
  }

  .pop-wrapper {
    text-align: center;
    letter-spacing: 20px;
    color: #999;
  }
</style>
